<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #cost="{ visible, params, close }">
			<CostPage :rows="params" :close="close" v-if="visible" />
    </template>
    <template #income="{ visible, params, close }">
      <IncomePage :rows="params" :close="close" v-if="visible" />
    </template>
		<template #TABS="{ visible, params, close }">
			<Tabs v-if="visible" :value="params.tab">
					<TabPane :label="$t('detail')" name="detail">
						<Detail :form="form" :height="320" :rows="params" :close="close"></Detail>
					</TabPane>
					<TabPane v-if="$hasPermission(984)" :label="$t('airIncome')" name="income">
						<IncomePage :height="630" :rows="Object.assign(params,{resType:2})" :close="close" />
					</TabPane>
					<TabPane v-if="$hasPermission(840)" :label="$t('agentT')+$t('finalCost')" name="cost">
						<CostPage :height="600" :rows="Object.assign(params,{resType:2})" :close="close" />
					</TabPane>
			</Tabs>
		</template>
  </cTable>
</template>

<script>
import {
  operAirOrder,
  getTransportAgent,
  getZhongGangList,
  getZhongGangCount,
  getCustomer,
  importCost,
  importIncome,
  createBill,
	businessType,
	getCustomerInfo,
	airPortName,
	getPackingInfo,
	getLoadType,
} from "@/api/tracker/air";
import {
	share,
} from "@/api/extract/list";
import {
	getConfig,
  getSubjectCost,
} from "@/api/tracker/cost_page";
import { getAllClient } from "@/api/user/client";
import { getSelectType, getKeysType } from "@/api/public";
import { dblpackingAir } from "@/api/packing/packing";
import { getCountry } from "@/api/system/country";
import { getExtractConfig, getExtractNotWarehouse } from "@/api/extract/new";
import { getAllService } from "@/api/user/internal";
import cTable from "@/base/common/index";
import CostPage from "@/view/trackers/cost_page";
import IncomePage from "../income/index.vue";
import Detail from "./detail.vue";
import { getAgent } from "@/api/tracker/agent";
export default {
  name: "airWaybillList",
  components: {
		Detail,
    cTable,
    CostPage,
    IncomePage,
  },

  async created() {
    let fromStation = (await dblpackingAir()).data.payload;
    let toStation = (await dblpackingAir()).data.payload;
    let clearance_agent = (await getTransportAgent({ type: 2 })).data
      .payload;
    let allAgent = (await getTransportAgent()).data.payload;
    let allClient = (await getAllClient()).data.payload.rows;
    let allService = (await getAllService()).data.payload;
		let config = (await getConfig()).data.payload;
		let baoguan_agent = (await getAgent()).data.payload.rows;
		let baoguan_agent1 = (await getTransportAgent({ type: 4 })).data
		  .payload;
		let load_type = (await getLoadType()).data.payload;
    this.$set(this.selData, "load_type", load_type);
    this.$set(this.selData, "fromStation", fromStation);
    this.$set(this.selData, "toStation", toStation);
    this.$set(this.selData, "clearance_agent", clearance_agent);
    this.$set(this.selData, "allAgent", allAgent);
    this.$set(this.selData, "allClient", allClient);
    this.$set(this.selData, "hk_agent", baoguan_agent1);
    this.header.searchs.forEach(async (item) => {
      if (item.key === "fromStation") item.options = this.selData.fromStation;
      if (item.key === "toStation") item.options = this.selData.toStation;
      if (item.key === "clearance_agent_id")
        item.options = this.selData.clearance_agent;
      if (item.key === "air_agent" || item.key === "baoguan_agent")
        item.options = this.selData.allAgent;
      if (item.key == "client_id") item.options = this.selData.allClient;
      if (item.key == "operator_id") item.options = allService[3];
    });
		this.modals.packingCostApportion.fields.forEach(async (el) => {
		  if (el.key == "currency") el.options = config.currency;
			if (el.key == "agent_id") el.options = baoguan_agent;
		});
  },
  methods: {},
  data() {
    let that = this;
    return {
			form:{
				config: {
				  listFn: "list",
				  modalBind: {
				    styles: {
				      top: "30px",
				    },
				    width: 90,
				  },
				  formBind: {
				    labelWidth: 150,
				  },
				  rowBind: {
				    gutter: 13,
				    style: {
				      marginBottom: "10px",
				    },
				  },
				  rules: {
				    // clearance_agent_id: [
				    //   {
				    //     required: true,
				    //     type: "number",
				    //     message: "clearance agent cannot be empty",
				    //     trigger: "blur"
				    //   }
				    // ],
				    from_station: [
				      {
				        required: true,
				        type: "string",
				        message: "from Station cannot be empty",
				        trigger: "change",
				      },
				    ],
				    to_station: [
				      {
				        required: true,
				        type: "string",
				        message: "to Station cannot be empty",
				        trigger: "change",
				      },
				    ],
				    dept_date: [
				      {
				        required: true,
				        type: "date",
				        message: "to Station cannot be empty",
				        trigger: "change",
				      },
				    ],
				    expected_date: [
				      {
				        required: true,
				        type: "date",
				        message: "to Station cannot be empty",
				        trigger: "change",
				      },
				    ],
				    flight: [
				      {
				        required: true,
				        type: "string",
				        message: "to Station cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    load_type: [
				      {
				        required: true,
				        type: "string",
				        message: "to Station cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    mawb: [
				      {
				        required: true,
				        type: "string",
				        message: "to Station cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    number_of_bags: [
				      {
				        required: true,
				        type: "number",
				        message: "to Station cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    shipping_mode: [
				      {
				        required: true,
				        type: "string",
				        message: "to Station cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    weight: [
				      {
				        required: true,
				        type: "string",
				        message: "weight cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    volume: [
				      {
				        required: true,
				        type: "string",
				        message: "volume cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    items: [
				      {
				        required: true,
				        type: "number",
				        message: "items cannot be empty",
				        trigger: "blur",
				      },
				    ],
				    air_line: [
				      {
				        required: true,
				        type: "string",
				        message: "air line cannot be empty",
				        trigger: "blur",
				      },
				    ],
				  },
				},
				grid: [
				  {client_id: 6,company: 6,user_name: 6,user_mobile: 6},
				  {create_time: 6,sale_name: 6,operator_name: 6,business_type: 6},
				  {"mawb": 6,"shipping_mode": 6,"air_line": 6,"flight": 6},
				  {"from_station": 6,"from_station_name": 6,"expected_date": 6},
				  {"to_station": 6,"to_station_name": 6,"dept_date": 6},
				  {"weight": 6,"volume": 6,"items": 6},
				  {"air_agent": 6,"hk_agent": 6,"clearance_agent_id": 6,"load_type": 6},
				  {"file_agent": 6,"baoguan_agent": 6, packing_number: 6},
				  {"remarks": 12},
				],
				fields: [
					{
					  key: "hk_agent",
					  name: () => this.$t("HKagency"),
					  component: "Select",
					  isNumber: true,
					  isRequired: true,
					  placeholder() {
					    return this.$t("select") + this.$t("HKagency");
					  },
					  options: [],
					},
				  {
				    key: "client_id",
				    name: () => this.$t("clientName"),
				    component: "Select",
				    disabled: true,
				    placeholder() {
				      return this.$t("enter") + this.$t("clientName");
				    },
				    options: [],
				    config: { label: "account", value: "id" },
						methods:{
							list({formData}){
								getCustomerInfo({client_id:this.$modal.params.client_id,id:this.$modal.params.id}).then(res=>{
									if(res.data.status){
										Object.assign(this.$modal.params,res.data.payload)
										this.$forceUpdate()
									}
								})
							},
				    },
				  },
					{
						key:'business_type',
						name:this.$t("businessTypes"),
						component: "Select",
						options: [],
						placeholder() {
						  return this.$t("enter") + this.$t("businessTypes");
						},
						methods:{
							async list({field,row}){
								field.options = (await businessType()).data.payload
							}
						}
					},
					{
						key:'company',
						name:this.$t("customerCompanyName"),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
					{
						key:'user_name',
						name:this.$t("Contacts"),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
					{
						key:'user_mobile',
						name:this.$t("telephone"),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
					{
						key:'create_time',
						name:this.$t("entrust")+this.$t('date'),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
					{
						key:'sale_name',
						name:this.$t("businessUser"),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
					{
						key:'operator_name',
						name:this.$t("operate"),
						component: "Input",
						disabled:true,
						placeholder:()=>' '
					},
				  {
				    key: "mawb",
				    name: () => this.$t("airWaybillNumber"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("airWaybillNumber");
				    },
				    disabled: true,
				  },
				  {
				    key: "air_line",
				    name: () => this.$t("airLine"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("airLine");
				    },
				    // disabled: true,
				  },
				  {
				    key: "from_station",
				    name: () => this.$t("from_station"),
				    component: "Select",
				    placeholder() {
				      return (
				        this.$t("select") +
				        this.$t("from_station")
				      );
				    },
				    options: [],
						methods:{
							list({field}){
								airPortName({code:this.$modal.params[field.key]}).then(res=>{
									if(res.data.status){
										this.$modal.params[field.key+'_name'] = res.data.payload
									}
									this.$forceUpdate()
								})
							},
						}
				  },
					{
						key:'from_station_name',
						name:this.$t("from_station")+ this.$t("airport_name"),
						component: "Input",
						disabled:true,
						placeholder() {
						  return this.$t("from_station")+ this.$t("airport_name");
						},
					},
				  {
				    key: "to_station",
				    name: () => this.$t("to_station"),
				    component: "Select",
				    // config: {
				    //   label: "name",
				    //   value: "key",
				    // },
				    placeholder() {
				      return (
				        this.$t("select") +
				        this.$t("to_station")
				      );
				    },
				    options: [],
				    // config: {
				    //   label: "code",
				    //   value: "code",
				    // },
						methods:{
							list({field}){
								airPortName({code:this.$modal.params[field.key]}).then(res=>{
									if(res.data.status){
										this.$modal.params[field.key+'_name'] = res.data.payload
									}
									this.$forceUpdate()
								})
							},
						}
				  },
					{
						key:'to_station_name',
						name:this.$t("to_station") + this.$t("airport_name"),
						component: "Input",
						disabled:true,
						placeholder() {
						  return this.$t("to_station") + this.$t("airport_name");
						},
					},
				  {
				    key: "expected_date",
				    name: () => this.$t("amount_actual") + this.$t("takeOffTime"),
				    component: "DatePicker",
				    disabledDate: true,
				    bind: {
				      type: "datetime",
				    },
				    placeholder() {
				      return (
				        this.$t("enter") +
				        this.$t("amount_actual") +
				        this.$t("takeOffTime")
				      );
				    },
				  },
				  {
				    key: "dept_date",
				    name: () => this.$t("amount_actual") + this.$t("landingTime"),
				    component: "DatePicker",
				    disabledDate: true,
				    bind: {
				      type: "datetime",
				    },
				    placeholder() {
				      return (
				        this.$t("enter") +
				        this.$t("amount_actual") +
				        this.$t("landingTime")
				      );
				    },
				  },
				  // {
				  //   key: "arrival_HK_date",
				  //   name: () => this.$t("arrival_HK_date"),
				  //   component: "DatePicker",
				  //   bind: {
				  //     type: "datetime"
				  //   },
				  //   placeholder() {
				  //     return this.$t("enter") + this.$t("arrival_HK_date");
				  //   }
				  // },
				  // {
				  //   key: "depart_date",
				  //   name: () => this.$t("depart_date"),
				  //   component: "DatePicker",
				  //   bind: {
				  //     type: "datetime"
				  //   },
				  //   placeholder() {
				  //     return this.$t("enter") + this.$t("depart_date");
				  //   }
				  // },
				  // {
				  //   key: "arrival_date",
				  //   name: () => this.$t("arrival_date"),
				  //   component: "DatePicker",
				  //   bind: {
				  //     type: "datetime"
				  //   },
				  //   placeholder() {
				  //     return this.$t("enter") + this.$t("arrival_date");
				  //   }
				  // },
				  {
				    key: "clearance_date",
				    name: () => this.$t("clearance_date"),
				    component: "DatePicker",
				    bind: {
				      type: "datetime",
				    },
				    placeholder() {
				      return this.$t("enter") + this.$t("clearance_date");
				    },
				  },
				  {
				    key: "flight",
				    name: () => this.$t("flight"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("flight");
				    },
				  },
				  {
				    key: "load_type",
				    name: () => this.$t("load_type"),
				    component: "Select",
				    placeholder() {
				      return this.$t("select") + this.$t("load_type");
				    },
				    options: [],
				    // disabled: true,
				  },
				  {
				    key: "shipping_mode",
				    name: () => this.$t("shipping_mode"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("shipping_mode");
				    },
				    // disabled: true,
				  },
				  {
				    key: "weight",
				    name: () => this.$t("Weight"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("Weight");
				    },
				  },
				  {
				    key: "volume",
				    name: () => this.$t("square") + "(CBM)",
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("square") + "(CBM)";
				    },
				  },
				  {
				    key: "items",
				    name: () => this.$t("invoicePCS"),
				    component: "Input",
				    placeholder() {
				      return this.$t("enter") + this.$t("invoicePCS");
				    },
				  },
				  {
				    key: "clearance_agent_id",
				    name: () => this.$t("clearagent"),
				    component: "Select",
				    options: [],
				    placeholder() {
				      return this.$t("select") + this.$t("clearagent");
				    },
				    // disabled: true,
				  },
				  {
				    key: "baoguan_agent",
				    name: () => this.$t("warehousCustomsAgent"),
				    component: "Select",
				    options: [],
				    placeholder() {
				      return this.$t("select") + this.$t("warehousCustomsAgent");
				    },
				  },
				  {
				    key: "air_agent",
				    name: () => this.$t("air_agent"),
				    component: "Select",
				    options: [],
				    placeholder() {
				      return this.$t("select") + this.$t("air_agent");
				    },
				  },
				  {
				    key: "file_agent",
				    name: () => this.$t("fileAgent"),
				    component: "Select",
				    options: [],
				    placeholder() {
				      return this.$t("select") + this.$t("fileAgent");
				    },
				  },
				  {
				    key: "remarks",
				    name: () => this.$t("Remarks"),
				    component: "Input",
				    bind: {
				      type: "textarea",
				    },
				    placeholder() {
				      return this.$t("enter") + this.$t("Remarks");
				    },
				  },
				],
			},
      selData: {
        toStation: [],
        fromStation: [],
        clearance_agent: [],
      },
      title: "",
      methods: {
        list: (p) => {
          p["method"] = p["method"] ? p["method"] : "get";
          return operAirOrder(p);
        },
				businessType,
				getCustomerInfo,
				airPortName,
				getPackingInfo,
        createBill,
        getSelectType,
        getCountry,
        dblpackingAir,
        getKeysType,
        getZhongGangList,
        getZhongGangCount,
        getAllClient,
        importCost,
        importIncome,
				share,
      },
      modals: {
        airIncome: {
          contentSlot: "income",
          config: {
            modalBind: {
              width: 70,
              draggable: true,
              sticky: true,
            },
            // modalContentBind: {
            //   style: {
            //     height: "600px"
            //   }
            // }
          },
          footer: {
            show: () => false,
          },
        },
        analysis: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("exportThatDay", row)
                .then((e) => {
                  window.open(this.$globalUrl + e.payload);
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 400,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  type: "date",
                  message: "analysis date cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ time: 24 }],
          fields: [
            {
              name: () => this.$t("analysisDate"),
              key: "time",
              component: "DatePicker",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("start") +
                  this.$t("date") +
                  this.$t("time")
                );
              },
              bind: {
                type: "date",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
              },
              methods: {
                format({ searchForm, value, newFormData }) {
                  return value
                    ? this.format.dateFormat(value, "YYYY-MM-DD")
                    : "";
                },
              },
            },
          ],
        },
        show: {
          config: {
            listFn: "list",
            modalBind: {
              width: 500,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              // {
              //   name: () => this.$t("orderNum"),
              //   key: "airway_number",

              //   tooltip: true,
              //   minWidth: 100
              // },
              {
                name: () => this.$t("packing_number"),
                key: "packing_number",

                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        uploadMsg: {
          config: {
            title: this.$t("updateFile") + this.$t("error_mes"),
            modalBind: {
              width: 500,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("error_mes"),
                key: "msg",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        openCost: {
          contentSlot: "cost",
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 90,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => false,
          },
        },
        update: {
					type:'add',
					contentBottom: "TABS",
          methods: {
            ok({ row, close }) {
              this.params["method"] = "put";
              this.$page.handleRequestMethods("list", this.params, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          footer: {
						show:()=>false,
            ok: {},
            cancel: {},
          },
          config: {
            listFn: "list",
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 90,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "10px",
              },
            },
            rules: {
              // clearance_agent_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "clearance agent cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              from_station: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change",
                },
              ],
              to_station: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              dept_date: [
                {
                  required: true,
                  type: "date",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              expected_date: [
                {
                  required: true,
                  type: "date",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              flight: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              load_type: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              mawb: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              number_of_bags: [
                {
                  required: true,
                  type: "number",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              shipping_mode: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              weight: [
                {
                  required: true,
                  type: "string",
                  message: "weight cannot be empty",
                  trigger: "blur",
                },
              ],
              volume: [
                {
                  required: true,
                  type: "string",
                  message: "volume cannot be empty",
                  trigger: "blur",
                },
              ],
              items: [
                {
                  required: true,
                  type: "number",
                  message: "items cannot be empty",
                  trigger: "blur",
                },
              ],
              air_line: [
                {
                  required: true,
                  type: "string",
                  message: "air line cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          // grid: [
          //   { client_id: 8, mawb: 8, air_line: 8 },
          //   { from_station: 8, to_station: 8, expected_date: 8 },
          //   // { dept_date: 8, depart_date: 8, arrival_date: 8 },
          //   { dept_date: 8, clearance_date: 8, shipping_mode: 8 },
          //   { flight: 8, load_type: 8, items: 8 },
          //   { weight: 8, volume: 8,  clearance_agent_id: 8 },
          //   { air_agent: 8, baoguan_agent: 8, file_agent: 8 },
          //   { remarks: 24 },
          // ],
          fields: [
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              component: "Select",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("clientName");
              },
              options: [],
              config: { label: "account", value: "id" },
              // methods: {
              //   async list({ field, row }) {
              //     let res = (await getAllClient()).data.payload.rows;
              //     field.options = res;
              //     this.$forceUpdate();
              //   }
              // }
            },
            {
              key: "mawb",
              name: () => this.$t("airWaybillNumber"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("airWaybillNumber");
              },
              disabled: true,
            },
            {
              key: "air_line",
              name: () => this.$t("airLine"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("airLine");
              },
              // disabled: true,
            },
            {
              key: "from_station",
              name: () => this.$t("from_station") + this.$t("airport_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("from_station") +
                  this.$t("airport_t")
                );
              },
              options: [],
            },
            {
              key: "to_station",
              name: () => this.$t("to_station") + this.$t("airport_t"),
              component: "Select",
              // config: {
              //   label: "name",
              //   value: "key",
              // },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("to_station") +
                  this.$t("airport_t")
                );
              },
              options: [],
              // config: {
              //   label: "code",
              //   value: "code",
              // },
            },
            {
              key: "expected_date",
              name: () => this.$t("amount_actual") + this.$t("takeOffTime"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime",
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("amount_actual") +
                  this.$t("takeOffTime")
                );
              },
            },
            {
              key: "dept_date",
              name: () => this.$t("amount_actual") + this.$t("landingTime"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime",
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("amount_actual") +
                  this.$t("landingTime")
                );
              },
            },
            // {
            //   key: "arrival_HK_date",
            //   name: () => this.$t("arrival_HK_date"),
            //   component: "DatePicker",
            //   bind: {
            //     type: "datetime"
            //   },
            //   placeholder() {
            //     return this.$t("enter") + this.$t("arrival_HK_date");
            //   }
            // },
            // {
            //   key: "depart_date",
            //   name: () => this.$t("depart_date"),
            //   component: "DatePicker",
            //   bind: {
            //     type: "datetime"
            //   },
            //   placeholder() {
            //     return this.$t("enter") + this.$t("depart_date");
            //   }
            // },
            // {
            //   key: "arrival_date",
            //   name: () => this.$t("arrival_date"),
            //   component: "DatePicker",
            //   bind: {
            //     type: "datetime"
            //   },
            //   placeholder() {
            //     return this.$t("enter") + this.$t("arrival_date");
            //   }
            // },
            {
              key: "clearance_date",
              name: () => this.$t("clearance_date"),
              component: "DatePicker",
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("clearance_date");
              },
            },
            {
              key: "flight",
              name: () => this.$t("flight"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("flight");
              },
            },
            {
              key: "load_type",
              name: () => this.$t("load_type"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("load_type");
              },
              // disabled: true,
            },
            {
              key: "shipping_mode",
              name: () => this.$t("shipping_mode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("shipping_mode");
              },
              // disabled: true,
            },
            {
              key: "weight",
              name: () => this.$t("Weight"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Weight");
              },
            },
            {
              key: "volume",
              name: () => this.$t("square") + "(CBM)",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("square") + "(CBM)";
              },
            },
            {
              key: "items",
              name: () => this.$t("invoicePCS"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
            },
            {
              key: "clearance_agent_id",
              name: () => this.$t("clearagent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("clearagent");
              },
              // disabled: true,
            },
            {
              key: "baoguan_agent",
              name: () => this.$t("warehousCustomsAgent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("warehousCustomsAgent");
              },
            },
            {
              key: "air_agent",
              name: () => this.$t("air_agent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("air_agent");
              },
            },
            {
              key: "file_agent",
              name: () => this.$t("fileAgent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("fileAgent");
              },
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
				packingCostApportion: {
				  methods: {
				    ok({ row, close }) {
				      this.$page
				        .handleRequestMethods("share", row)
				        .then((e) => {
									this.$page.getList()
				          close();
				        });
				    },
				  },
				  footer: {
				    ok: {},
				    cancel: {},
				  },
				  config: {
				    modalBind: {
				      width: 600,
				    },
				    formBind: {
				      labelWidth: 100,
				    },
				    rowBind: {
				      gutter: 13,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    rules: {
				      packing: [
				        {
				          required: true,
				          message: "cannot be empty",
				          trigger: "change",
				        },
				      ],
							expense_item: [
							  {
							    required: true,
							    message: "cannot be empty",
									type:'array',
							    trigger: "change",
							  },
							],
							currency: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							  },
							],
							amount: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
							  },
							],
							agent_id: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "change",
									type:'number'
							  },
							],
				    },
				  },
				  grid: [
						{ packing: 24 },
						{ expense_item: 24 },
						{ agent_id: 24 },
						{ currency: 24 },
						{ amount: 24 },
						{ remarks: 24 },
					],
				  fields: [
						{
						  key: "packing",
						  name: () => this.$t("packing_number"),
						  component: "Input",
						  bind: {
						    type: "textarea",
						  },
						  placeholder() {
						    return this.$t("enter") + this.$t("packing_number");
						  },
						},
						{
						  name: () => this.$t("expense"),
						  key: "expense_item",
						  minWidth: 120,
						  component: "Cascader",
						  placeholder() {
						    return this.$t("select") + this.$t("expense");
						  },
						  options: [],
							default:[],
						  methods: {
								async list({field}){
									field.options = (await getSubjectCost({ pid: 0 })).data.payload
								},
						    async loadData({ item, callback }) {
						      item.loading = true;
						      item.children = (
						        await getSubjectCost({ pid: item.value })
						      ).data.payload;
						      item.loading = false;
						      callback();
						    },
						  },
						},
						{
						  name: () => this.$t("agentName"),
						  key: "agent_id",
						  component:"Select",
						  placeholder() {
						    return this.$t("select") + this.$t("agentName");
						  },
						  options: [],
							config: {
							  label: "agent_name",
							  value: "id",
							},
						  disabled({ row }) {
						    return row.bill_id > 0;
						  },
							methods:{
								render({field,value}){
									return (field.options.find(t=>t.value === value) || {}).label || '-'
								}
							}
						},
						{
						  name: () => this.$t("calculation") + this.$t("currency_t"),
						  key: "currency",
						  placeholder() {
						    return (
						      this.$t("select") + this.$t("calculation") + this.$t("currency_t")
						    );
						  },
						  options: [],
							component:"Select",
							methods:{
								render({field,value}){
									return (field.options.find(t=>t.value === value) || {}).label || '-'
								},
							}
						},
						{
							key: "amount",
							name: () => this.$t("cost_fee"),
							bind: {
								style: {
									width: "100%",
								},
							},
							component: "Input",
							placeholder() {
								return this.$t("enter") + this.$t("cost_fee");
							},
						},
				    {
				      key: "remarks",
				      name: () => this.$t("Remarks"),
				      component: "Input",
				      bind: {
				        type: "textarea",
				      },
				      placeholder() {
				        return this.$t("enter") + this.$t("Remarks");
				      },
				    },
				  ],
				},
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["AIR_EXTRACT_SELECT_TYPE"]))
                  .data.payload["AIR_EXTRACT_SELECT_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },

          {
            key: "fromStation",
            placeholder() {
              return this.$t("select") + this.$t("from_station");
            },
            component: "Select",
            options: [],
          },
          {
            key: "toStation",
            placeholder() {
              return this.$t("select") + this.$t("to_station");
            },
            component: "Select",
            options: [],
            // config: {
            //   label: "code",
            //   value: "code",
            // },
          },
          {
            key: "costType",
            placeholder() {
              return this.$t("whether") + this.$t("costEntry");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [
              {
                label: "YES",
                value: "YES",
              },
              {
                label: "NO",
                value: "NO",
              },
            ],
          },
          {
            key: "clearance_agent_id",
            placeholder() {
              return this.$t("select") + this.$t("clearagent");
            },
            component: "Select",
            options: [],
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            config: { label: "account", value: "id" },
            // methods: {
            //   async list({ field, row }) {
            //     let res = (await getAllClient()).data.payload.rows;
            //     field.options = res;
            //     this.$forceUpdate();
            //   }
            // }
          },
          {
            key: "operator_id",
            component: "Select",
            placeholder() {
              return this.$t("createName");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px",
            },
            // methods: {
            //   async list({ field, row }) {
            //     let res = (await getAllClient()).data.payload.rows;
            //     field.options = res;
            //     this.$forceUpdate();
            //   }
            // }
          },
          {
            key: "finish",
            placeholder() {
              return this.$t("whether") + this.$t("complete");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [
              {
                label: "YES",
                value: 1,
              },
              {
                label: "NO",
                value: 2,
              },
            ],
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("EXTRACT_AIR_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download",
              },
              disabled(row) {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$t("template") + this.$t("download"),
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              list: [
                {
                  name: this.$t("finalCost") + this.$t("template"),
                  url: "/doc/zh-CN/cost.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary",
                  },
                },
                {
                  name: this.$t("income") + this.$t("template"),
                  url: "/doc/zh-CN/income.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary",
                  },
                },
              ],
            },
            {
              name: () => this.$t("finalCost") + this.$t("import"),
              fnName: "updateFile",
              type: "importCost",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("income") + this.$t("import"),
              fnName: "updateFile",
              type: "importIncome",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("createIncomeBill"),
              fnName: "createBill",
              type: "createBill",
              bind: {
                type: "primary",
              },
              id: 1019,
            },
						{
          	  name: () => this.$t("packing") + this.$t("apportion"),
          	  fnName: "packingCostApportion",
          	  type: "packingCostApportion",
          	  bind: {
          	    type: "primary",
          	  },
          	},
          ],
          methods: {
          	packingCostApportion(){
          		this.getModal('packingCostApportion').open({},function(){
          			this.setTitle(this.$t("packing") + this.$t("apportion"));
          		})
          	},
            createBill({ searchForm }) {
              this.handleRequestMethods(
                "createBill",
                searchForm,
                false,
                true
              ).then((res) => {
                this.$Message.success({
                  background: true,
                  content: res.message || res.msg || "success",
                  duration: 5,
                });
              });
            },
            down({ row, field, searchForm }) {
              window.open(this.$globalUrl + field.url);
            },
            // analysisFun({ field, searchForm }) {
            //   this.getModal("analysis").open({}, function() {
            //     this.setTitle(this.$t("analysis"));
            //   });
            // },
            exportFun({ row, field, searchForm }) {
              this.exportExc();
            },
            updateFile({ file, field, searchForm }) {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", "2");
              this.$page
                .handleRequestMethods(field.type, formData, false, true)
                .then((res) => {
                  if (res.payload.length) {
                    this.$page.getModal("uploadMsg").open(null, function () {
                      this.setTitle(
                        this.$t("import") +
                          (field.type == "importIncome"
                            ? this.$t("income")
                            : this.$t("finalCost")) +
                          this.$t("info")
                      );
                      this.list = res.payload;
                    });
                  } else {
                    this.$Message.success(
                      this.$t("updateFile") + this.$t("success")
                    );
                  }
                });
              return false;
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: () => this.$t("entryNo"),
          key: "airway_number",
          minWidth: 120,
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          minWidth: 120,
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "items",
          minWidth: 120,
        },
        {
          name: this.$t("createUser"),
          key: "operator_name",
          minWidth: 100,
        },
        {
          name: this.$t("clientName"),
          key: "client_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("clearagent"),
          key: "clearance_agent",
          minWidth: 120,
        },
        {
          name: () => this.$t("warehousCustomsAgent"),
          key: "baoguan_agent_name",
          minWidth: 120,
        },
        {
          name: () => this.$t("air_agent"),
          key: "air_agent_name",
          minWidth: 120,
        },
        {
          name: () => this.$t("fileAgent"),
          key: "file_agent_name",
          minWidth: 120,
        },
        {
          name: () => this.$t("flight"),
          key: "flight",
          minWidth: 100,
        },
        {
          name: () => this.$t("to_station") + this.$t("airport_t"),
          key: "to_station",
          minWidth: 80,
        },
        {
          name: () => this.$t("amount_actual") + this.$t("takeOffTime"),
          key: "expected_date",
          minWidth: 130,
        },
        {
          name: () => this.$t("amount_actual") + this.$t("landingTime"),
          key: "dept_date",
          minWidth: 130,
        },
        // {
        //   name: () => this.$t("arrival_date"),
        //   key: "arrival_date",
        //   minWidth: 130
        // },

        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "left",
          width: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
        },
        {
          type: "btns",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            // {
            //   name: () => this.$t("airIncome"),
            //   type: "airIncome",
            //   fnName: "airIncome",
            //   bind: {
            //     type: ({ row }) => {
            //       return row.incomeType !== "NO" ? "warning" : "default";
            //     },
            //   },
            //   id: 984,
            // },
            // {
            //   name: () => this.$t("agentT") + this.$t("finalCost"),
            //   type: "openCost",
            //   fnName: "openCost",
            //   data: {
            //     type: 2,
            //   },
            //   bind: {
            //     type: ({ row }) => {
            //       return row.costType !== "NO" ? "warning" : "default";
            //     },
            //   },
            //   id: 840,
            // },
            // {
            //   name: () => "报关代理成本",
            //   type: "openCost1",
            //   fnName: "openCost",
            //   data: {
            //     type: 2
            //   },
            //   bind: {
            //     type: "warning"
            //   },
            //   id: 840
            // },
            // {
            //   name: () => this.$t("show"),
            //   type: "show",
            //   fnName: "showFun",
            //   bind: {
            //     type: "primary"
            //   }
            //   // id: 514
            // },
            // {
            //   name: () => this.$t("export"),
            //   type: "export",
            //   fnName: "exportFun",
            //   bind: {
            //     type: "warning"
            //   }
            // },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
              id: 792,
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              id: 793,
            },
          ],

          methods: {
            airIncome({ row }) {
              row.resType = 2;
              this.getModal("airIncome").open(row, function () {
                this.setTitle(this.$t("airIncome"));
              });
            },
            openCost({ row, field }) {
              row.resType = field.data.type;
              this.getModal("openCost").open(row, function () {
                this.setTitle(this.$t("agentT") + this.$t("finalCost"));
              });
            },
            async showFun({ row }) {
              let res = await this.handleRequestMethods(
                "getZhongGangCount",
                row.id
              );

              this.getModal("show").open({ data: res.payload.rows }, () => {
                this.getModal("show").setTitle(this.$t("show") + row.mawb);
                // this.getModal("show").table.fields[0].name = () => {
                //   return (
                //     this.$t("orderNum") + `(${res.payload.airway_bill_total})`
                //   );
                // };
                this.getModal("show").table.fields[0].name = () => {
                  return (
                    this.$t("packing_number") +
                    `(${res.payload.packing_number_total})`
                  );
                };
                this.getModal("show").list = res.payload.row;
              });
            },
            // exportFun({ row }) {
            //   console.log("导出");
            //   this.openLoading();
            //   this.handleRequestMethods(
            //     "getExportExcel",
            //     row.id,
            //     false,
            //     true
            //   ).then(res => {
            //     console.log(res);
            //     window.open(this.$globalUrl + res.payload);
            //   });
            // },
            async updateFun({ row }) {
              let data = {
                method: "get",
                id: row.id,
              };
              // this.openLoading();
              let res = await this.handleRequestMethods("list", data);
              let packing = await this.handleRequestMethods(
                "getZhongGangList",
                row.id,
                false,
                true
              );
              that.form.fields.forEach(async (item) => {
								if (item.key === "load_type")
								  item.options = that.selData.load_type;
                if (item.key === "from_station")
                  item.options = that.selData.fromStation;
								if (item.key === "hk_agent")
									item.options = that.selData.hk_agent;
                if (item.key === "to_station")
                  item.options = that.selData.toStation;
                if (item.key === "clearance_agent_id")
                  item.options = that.selData.clearance_agent;
                if (item.key === "file_agent") {
                  item.options = that.selData.allAgent;
                }
                if (item.key === "air_agent" || item.key === "baoguan_agent")
                  item.options = that.selData.allAgent;
                if (item.key == "client_id") {
                  item.options = that.selData.allClient;
                }
              });
							res.payload.packing = packing.payload
							res.payload.tab = 'detail'
              this.getModal("update").open(res.payload, function () {
                this.setTitle(this.$t("update"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("mawb") +
                  ":" +
                  row.mawb +
                  "?",
                onOk: () => {
                  row["method"] = "delete";
                  this.handleRequestMethods("list", row, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
.content {
  height: 100%;
}
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
